import { dew as _resolveConfig2Dew } from "../util/resolveConfig";
import { dew as _getAllConfigs2Dew } from "../util/getAllConfigs";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function () {
      return resolveConfig;
    }
  });
  const _resolveConfig = /*#__PURE__*/_interop_require_default(_resolveConfig2Dew());
  const _getAllConfigs = /*#__PURE__*/_interop_require_default(_getAllConfigs2Dew());
  function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function resolveConfig(...configs) {
    let [, ...defaultConfigs] = (0, _getAllConfigs.default)(configs[0]);
    return (0, _resolveConfig.default)([...configs, ...defaultConfigs]);
  }
  return exports;
}